<template>
  <div class="m4u_text--text m4u_tertiary ml-5 mr-5">
<h3 class="m4u_text--text ml-5">Memories for Us Credits</h3>
<p class="m4u_text--text ml-5">I'm Athelene Gosnell, the "creator" of Memories For Us. I use the word creator in quotes because no one person can really claim the title. 
  This app would never have taken place without help of so many people. The following are just some of them and how they helped.</p>
<ul class="ml-6">
  <li class="m4u_text--text">Jim Gosnell who never said it's time to give up, even when he could have.</li>
  <li class="m4u_text--text">August Gieseman for technical support, vision, emotional support and incredible patience.</li>
  <li class="m4u_text--text">Hillary Shepard for her encouragement and expertise in showing us all how to create positive connections with friends and family online.</li>
  <li class="m4u_text--text">So many people in the senior care industry who encouraged me to not give up trying to help families stay connected. </li>
  <li class="m4u_text--text">joni newcomer for her help in making the app look bright and inviting, easier to read, creating content and testing.</li>
  <li class="m4u_text--text">Annette Shewmake for agreeing to test and make suggestions.</li>
  <li class="m4u_text--text">Kathy Tisdale for her help and enouragement in developing interview question suggestions.</li>
  <li class="m4u_text--text">A long list of people who freely publish technical guidance online. The amount of sharing that is done in this community is amazing. 
    There are thousands on StackOverflow, GitHub, YouTube, Medium and countless blogs. These folks contribute untold hours for the benefit of all developers. You all ROCK! Some of the 
    people who fall into this category who provided specific and significant help are: <a href="https://stackoverflow.com/users/188096/gaurav-mantri" target="blank">
    Gaurav Mantri</a>, <a href="https://stackoverflow.com/users/75838/joel-cochran" target="blank">Joel Cochran</a>, <a href="https://www.youtube.com/channel/UChwzyfg_8WEPe9oRTqZ50RA" 
    target="blank">Rohan Arora</a>, <a href="https://www.youtube.com/channel/UCFbNIlppjAuEX4znoulh0Cw" target="blank">Kyle at WebDev Simplified</a>, 
    <a href="https://www.youtube.com/kepowob" target="blank">Kevin Powell</a>, <a href="https://www.youtube.com/c/Geek97/about">Geek 97</a>, and a HUGE shout out to <a href="https://www.youtube.com/c/TheNetNinja/about" target="blank">Shaun Pelling</a> 
    for his tutorials on Vue.js and more.
  </li>
</ul>
</div>

</template>

<script>
export default {
  name: "credits",

  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
body {
  background: green;
}
.org-description {
  margin-top: 50px;
}
</style>
